import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { Iobject } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { isType, isType3, userTypeList } from 'main_consts';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import {
  getExcel,
  blobDownload,
  getSearch,
  snackBarRsp,
  postAsynchronousDownloadInOutStatFile,
} from 'main_api';
import MonthOneSePickersTyping from 'components/DatePicker/MonthOneSePickersTyping';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';
import { EnumTimeCheck } from 'enum';
import CheckBox from 'components/Material/Checkbox';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  formatDateTime,
  getDateDayPlus,
  getWarehouse,
  inputChange,
  radioChange,
  getExpressName,
  initWhrehhouse,
  checkboxChange,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, VcEGrid, VcGrid } from '../../../components/Grid';
import { IData, Imaster } from './type';
import MyTable from './Table/MyTable';

/** 進出倉貨量統計表 */
const MisInOutStatQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 進出口別
    declType: '1',
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    declYYMM: getDateDayPlus(),
    /** 到櫃日期 */
    etaDate: getDateDayPlus(),
    /** 通關日期 */
    declDate: getDateDayPlus(),

    etaDateChk: '0',
    declDateChk: '0',
  };
  const apiName = 'misInOutStatQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [randomValue, setRandomValue] = useState(Math.random());
  const [tbData, setTbData] = useState<IData[]>([]);

  useEffect(() => {
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.topType, userType) ||
        isType(userTypeList.type4, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postAsynchronousDownloadInOutStatFile(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      declYYMM: master.declYYMM,
      etaDate: master.etaDateChk === '1' ? master.etaDate : '',
      declDate: master.declDateChk === '1' ? master.declDate : '',
    });

    dispatch(setLoadingRedux(false));
    snackBarRsp(enqueueSnackbar, result);
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      declYYMM: master.declYYMM,
      etaDate: master.etaDateChk === '1' ? master.etaDate : '',
      declDate: master.declDateChk === '1' ? master.declDate : '',
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;
    const data = dataTemp as Imaster[];
    if ((data || []).length > 0) {
      setTbData(dataTemp as IData[]);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    // if (master.startDate.length === 0) {
    //   master.startDate = getDateDayPlus();
    // }
    // if (master.endDate.length === 0) {
    //   master.endDate = getDateDayPlus();
    // }
    // if (
    //   !master.endDateValid ||
    //   !master.endTimeValid ||
    //   !master.startDateValid ||
    //   !master.startTimeValid ||
    //   !(
    //     master.startDate &&
    //     master.endTime &&
    //     master.startDate &&
    //     master.startTime
    //   )
    // ) {
    //   return;
    // }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">進出倉貨量統計表</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 進出倉貨量統計表
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="declType"
                value={master.declType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </VcGrid>
          </Grid>
          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={2}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*通關月份：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2} style={{ maxWidth: 800 }}>
              {/* TODO */}

              <MonthOneSePickersTyping
                key={random}
                required
                updateData={updateData}
                style={{ maxWidth: 800 }}
                inputDataName="declYYMM"
                data={master}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>到櫃日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2} style={{ maxWidth: 800 }}>
              {/* TODO */}

              <DateOneSePickersTyping
                key={random}
                required
                disabled={master.etaDateChk === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                inputDataName="etaDate"
                data={master}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入到櫃日期查詢"
                checked={master.etaDateChk === '1'}
                name="etaDateChk"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    declDate: masterDefaultValue.etaDate,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>通關日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2} style={{ maxWidth: 800 }}>
              {/* TODO */}

              <DateOneSePickersTyping
                key={random}
                required
                disabled={master.declDateChk === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                inputDataName="declDate"
                data={master}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入通關日期查詢"
                checked={master.declDateChk === '1'}
                name="declDateChk"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    declDate: masterDefaultValue.declDate,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      <div>{openSearchTable && <MyTable data={tbData} />}</div>
    </div>
  );
};

export default MisInOutStatQry;
